<template>
  <div :class="{ 'service-row-collapsed': collapsed }">
    <div class="dropdown-category pointer"
         @click="toggleCollapse"
         :class="{ 'pl-5': subcategory, 'pl-4': !subcategory }">
      <ArrowSvg class="collapse-svg svg-gray"/>
      {{ categoryData.category.title }}
    </div>
    <div class="dropdown-services-wrapper">
      <div v-for="service in categoryData.services"
           class="dropdown-service break-all"
           :class="{ selected: false }"
           @click="select(service)"
           :key="`opt-${service.id}`">
        <div class="dropdown-wrapper dropdown-menu-teeth"
             @click.stop>
          <VisitServicePerToothDropdown :readonly="readonly"
                                        :minAmount="applied(service.id)"
                                        v-click-outside="clickOutsideTeethQuantity"
                                        v-if="!readonly && selectedServiceId === service.id"
                                        :service="service"
                                        :teeth="teeth"/>
        </div>
        <div class="row no-gutters gap-2">
          <div class="col">
            <div>{{ (service.cod ? service.cod+'. ' : '') + service.name }}</div>
            <div class="small text-muted"
                 v-if="service.price_p">{{ service.price_p }}</div>
          </div>
          <div class="col-auto">
            {{ formatCurrency(service.cost_branch || service.cost) }}
          </div>
          <div class="col-auto">
            <span v-if="servicesById[service.id]"
                  @click.stop="toggleDetails(service.id)">
              <span>{{ servicesById[service.id].teeth.length }}</span>
              <ArrowSvg class="ml-1 svg-primary"/>
            </span>
            <span v-else class="plus-icon">
              <PlusSvg class="svg-white svg-size-xs"/>
            </span>
          </div>
        </div>

      </div>
      <slot/>
    </div>
  </div>
</template>

<script setup>
import {formatCurrency} from "@/extensions/filters/filters"
import ArrowSvg from "@/assets/svg-vue/general/arrow_down2_tr.svg.vue"
import PlusSvg from "@/assets/svg-vue/header/plus_t.svg.vue"
import VisitServicePerToothDropdown from "@/components/parts/patients/visit/teethTab/VisitServicePerToothDropdown.vue"
import {copyObject} from "@/extensions/prototypes/prototypes"
import {computed, onMounted, ref, watch} from "vue"
import {calculateAppliedVsTotalStats} from "@/services/teeth.helper"
import {useStore} from "vuex"

const props = defineProps({
  teeth: Array,
  categoryData: {},
  servicesById: {},
  readonly: {},
  subcategory: {
    type: Boolean,
    default: false
  },
  search: {
    type: String
  },
  initiallyOpened: {
    type: Boolean,
  },
  commonSelectedServiceId: {
    type: Number,
    required: false
  },
  view: {
    type: String,
    default: 'visit'
  }
})

const store = useStore()

const collapsed = ref(false)
const selectedServiceId = ref(null)
const justOpened = ref(false)
const visit = computed(() => store.state.patient.visit)

const emit = defineEmits(['select', 'selectedServiceId'])
const applied = (serviceId) => {
  if(props.view !== 'planning') return -1
  return calculateAppliedVsTotalStats(visit.value, copyObject(props.teeth), serviceId)?.applied || -1
}

const select = async (service) => {
  if(props.readonly) return
  if(selectedServiceId.value === service.id) {
    return
  }
  emit('select', copyObject(service))
}

const toggleDetails = (serviceId) => {
  if(selectedServiceId.value === serviceId) {
    selectedServiceId.value = null
  } else {
    selectedServiceId.value = serviceId
    justOpened.value = true
    setTimeout(() => {
      justOpened.value = false
    }, 100)
  }
}

const clickOutsideTeethQuantity = () => {
  if(!justOpened.value) {
    setTimeout(() => {
      selectedServiceId.value = null
    }, 10)

  }
}

onMounted(() => {
  collapsed.value = !props.initiallyOpened
})

watch(() => props.search, () => {
  collapsed.value = false
})

watch(selectedServiceId, (val) => {
  emit('selectedServiceId', val)
})

watch(() => props.commonSelectedServiceId, (val) => {
  if(val && val !== selectedServiceId.value) {
    selectedServiceId.value = null
  }
})

const toggleCollapse = () => {
  collapsed.value = !collapsed.value
}
</script>

<style scoped lang="scss">
.dropdown-search {
  .dropdown-service, .dropdown-category {
    padding: 3px 10px;
  }
  .dropdown-category {
    background: #f2f2f2;
    color: rgba(0,0,0,0.8);
  }

  .dropdown-service {
    cursor: pointer;
    position: relative;
    &:hover {
      background: $body-bg;
    }
    .dropdown-wrapper {
      position: absolute;
      right: 20px;
      top: 20px;
      z-index: 1;
      width: 130px;
    }
  }
  .plus-icon {
    width: 14px;
    height: 14px;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    border-radius: 4px;
    background-color: $blue-color;
    font-size: 0;
  }


}
.collapse-svg {
  transition: 0.3s all;
}
.service-row-collapsed {
  .dropdown-services-wrapper {
    overflow: hidden;
    height: 0;
  }
  > .dropdown-category {
    .collapse-svg {
      transform: rotate(180deg);
    }
  }
}

</style>
